// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2024 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { DocumentData } from "firebase/firestore";

import {
  UsTnAnnualReclassificationReviewRecord,
  usTnAnnualReclassificationReviewSchema,
} from "~datatypes";
import { formatDate } from "~utils";

import { OpportunityUpdateWithForm } from "../../../../FirestoreStore";
import { Resident } from "../../../Resident";
import { UsTnReclassificationReviewForm } from "../../Forms/UsTnReclassificationReviewForm";
import { OpportunityBase } from "../../OpportunityBase";
import { UsTnSharedReclassificationDraftData } from "../UsTnSharedCriteria";

export const NO_RELEASE_DATE_TEXT =
  "This resident's release date is currently not available. If applicable, please update TOMIS with the latest judgment order.";
export class UsTnAnnualReclassificationReviewOpportunity extends OpportunityBase<
  Resident,
  UsTnAnnualReclassificationReviewRecord["output"],
  OpportunityUpdateWithForm<UsTnSharedReclassificationDraftData>
> {
  form: UsTnReclassificationReviewForm;

  constructor(resident: Resident, record: DocumentData) {
    super(
      resident,
      "usTnAnnualReclassification",
      resident.rootStore,
      usTnAnnualReclassificationReviewSchema.parse(record),
    );

    this.form = new UsTnReclassificationReviewForm(this, resident.rootStore);
  }

  get eligibilityDate() {
    return super.eligibilityDate ?? this.record?.formReclassificationDueDate;
  }

  showEligibilityStatus(): boolean {
    return true;
  }

  get eligibleStatusMessage() {
    if (this.eligibilityDate) {
      return `Due ${formatDate(this.eligibilityDate)}`;
    }
    return "Not Yet Classified";
  }

  get previewBannerText() {
    if (!this.person.releaseDate) {
      return NO_RELEASE_DATE_TEXT;
    }
  }
}
